import * as React from "react";
import { Button, Modal } from "react-bootstrap";
import LogoutBtn from "../LogoutBtn";

interface IModalHeaderProps {
  onClick?: () => void;
  children?: any;
}

const ModalHeader: React.SFC<IModalHeaderProps> = ({ onClick, children }) => (
  <Modal.Header>
    <div className="modal-header__btns">
      <LogoutBtn size="xsmall" />
      <Button bsSize="xsmall" className="btn-warning" onClick={onClick}>
        Close
      </Button>
    </div>
    {children}
  </Modal.Header>
);

export default ModalHeader;
